jQuery(document).ready(function ($) {
    let newsletter_form = document.getElementById('newsletter-form');
    // Formular nemusi byt na strance - bez nej nic neinicializuj.
    if (!newsletter_form) {
        return;
    }
    let email = newsletter_form.querySelector('input[name="email"]');

    let alert_msg = $('#newsletter-alert-message');
    alert_msg.hide();

    function showAlertMessage(message, isSuccess = true) {
        alert_msg.find('.alert-message').text(message);

        if (isSuccess) {
            alert_msg.removeClass('alert-danger').addClass('alert-success');
        } else {
            alert_msg.removeClass('alert-success').addClass('alert-danger');
        }

        alert_msg.show();
    }

    function validateEmail(email) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    $('#newsletter-form').on('submit', function (event) {
        event.preventDefault();
        let form = $(this);

        alert_msg.hide();
        alert_msg.find('.alert-message').text('');

        let email = this.email.value;
        let recaptcha_response = this.recaptcha_response.value;

        if (!validateEmail(email)) {
            showAlertMessage("Neplatná e-mailová adresa.", false);
            return;
        }

        // AJAX call
        $.ajax({
            type: 'POST', url: MyAjax.ajaxurl, data: {
                action: 'handle_newsletter_form_submission', email: email, nonce: MyAjax.nonce, recaptcha_response: recaptcha_response
            }, success: function (response) {
                if (response.success) {
                    showAlertMessage(response.data, true);
                    form[0].reset();
                    form.hide();
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        event: 'form_submit',
                        form:  'newsletter-form',
                        customer: {
                            email: email,
                        }
                    });
                } else {
                    showAlertMessage(response.data, false);
                }
            }, error: function (xhr, status, error) {
                showAlertMessage(xhr.responseJSON.data, false);
            }
        });
    });
});